<template>
  <div class="tree flex" v-show="department.name">
    <ul>
      <li>
        <a  @click="getDetail(department,$event)" :class="department.departments?'':'click'"
           style="height: 56px;line-height: 46px">{{department.name}}</a>
        <ul>
          <li v-for="a in department.departments">
            <a  @click="getDetail(a,$event)">{{a.name}}</a>
            <ul v-if="a.departments&&a.departments.length > 0">
              <li v-for="b in a.departments">
                <a @click="getDetail(b,$event)">{{b.name}}</a>
                <ul v-if="b.departments&&b.departments.length > 0">
                  <li v-for="c in b.departments">
                    <a @click="getDetail(c,$event)">{{c.name}}</a>
                    <ul v-if="c.departments&&c.departments.length > 0">
                      <li v-for="d in c.departments">
                        <a @click="getDetail(d,$event)">{{d.name}}</a>
                        <ul v-if="d.departments&&d.departments.length > 0">
                          <li v-for="e in d.departments">
                            <a @click="getDetail(e,$event)">{{e.name}}</a>
                            <ul v-if="e.departments&&e.departments.length > 0">
                              <li v-for="f in e.departments">
                                <a @click="getDetail(f,$event)">{{f.name}}</a>
                                <ul v-if="f.departments&&f.departments.length > 0">
                                  <li v-for="g in f.departments">
                                    <a @click="getDetail(g,$event)">{{g.name}}</a>
                                    <ul v-if="g.departments&&g.departments.length > 0">
                                      <li v-for="h in g.departments">
                                        <a @click="getDetail(h,$event)">{{h.name}}</a>
                                        <ul v-if="h.departments&&h.departments.length > 0">
                                          <li v-for="i in h.departments">
                                            <a @click="getDetail(i,$event)">{{i.name}}</a>
                                            <ul v-if="i.departments&&i.departments.length > 0">
                                              <li v-for="j in i.departments">
                                                <a @click="getDetail(j,$event)">{{j.name}}</a>
                                              </li>
                                            </ul>
                                          </li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
  export default{
    name: 'chart-tree',
    props: ['url','data-url','data-tree'],
    data(){
      return {
        department: this.dataTree || {}
      }
    },
    mounted(){
        if(this.dataUrl){
          this.$http$({method: 'get', url: this.dataUrl}, (data) => {
            this.department = data
          })
        }

    },
    methods:{
      getDetail(obj,e){
        $('.tree a').removeClass('click')
        $(e.target).addClass('click')
        this.$emit('on-click',obj)
      },
    },
    watch:{
        dataTree(val){
            this.department = val
        }
    }
  }
</script>
<style scoped>
  .tree{
    line-height: 26px;
  }
  .tree ul {
    padding-left: 20px;
    position: relative;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
  }

  .tree li {
    float: left;
    text-align: center;
    list-style-type: none;
    position: relative;
    padding: 5px 0 5px 20px;

    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
  }

  /*We will use ::before and ::after to draw the connectors*/

  .tree li::before, .tree li::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 50%;
    border-bottom: 1px solid #ccc;
    width: 20px;
  }

  .tree li::after {
    top: 0;
    left: 0;
    bottom: 0;
    border-left: 1px solid #ccc;
    border-bottom: none;
  }

  /*We need to remove left-right connectors from elements without
  any siblings*/
  .tree > ul > li:only-child::after, .tree > ul > li:only-child::before {
    display: none;
  }

  /*Remove space from the top of single children*/
  /*.tree li:only-child{ padding-top: 0;}   */

  /*Remove left connector from first child and
  right connector from last child*/
  .tree li:first-child::after {
    top: 50%;
  }

  .tree li:last-child::after {
    bottom: 50%;

  }

  /*Adding back the vertical connector to the last nodes*/
  /*.tree li:last-child::before{*/
  /*border-bottom: 1px solid #ccc;*/
  /*border-radius: 0 5px 0 0;*/
  /*-webkit-border-radius: 0 5px 0 0;*/
  /*-moz-border-radius: 0 5px 0 0;*/
  /*}*/
  /*.tree li:first-child::after{*/
  /*border-radius: 5px 0 0 0;*/
  /*-webkit-border-radius: 5px 0 0 0;*/
  /*-moz-border-radius: 5px 0 0 0;*/
  /*}*/

  /*Time to add downward connectors from parents*/
  .tree ul {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }

  .tree ul li {
    display: flex;
    align-items: center;

  }

  .tree ul ul::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 50%;
    left: 0;
    border-bottom: 1px solid #ccc;
    width: 0;
    width: 20px;
  }

  .tree li a {
    border: 1px solid #ccc;
    padding: 5px 10px;
    text-decoration: none;
    color: #666;
    font-family: arial, verdana, tahoma;
    font-size: 11px;
    display: inline-block;

    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;

    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
  }

  .tree li .click {
    background: #c8e4f8;
    color: #000;
    border: 1px solid #94a0b4;
  }

  /*Time for some hover effects*/
  /*We will apply the hover effect the the lineage of the element also*/
  .tree li a:hover {
    background: #c8e4f8;
    color: #000;
    border: 1px solid #94a0b4;
  }

  .tree li a:hover + ul li a {
    background: #eee;
    color: #000;
    border: 1px solid #94a0b4;
  }

  /*Connector styles on hover*/
  .tree li a:hover + ul li::after,
  .tree li a:hover + ul li::before,
  .tree li a:hover + ul::before,
  .tree li a:hover + ul ul::before {
    border-color: #94a0b4;
  }

</style>



// WEBPACK FOOTER //
// src/components/ChartTree.vue